export default {
  initialized: false,
  item: {},
  email_change: {}
};
